<template>
  <div>
    <h1>Generate PDF</h1>
    <p>This is the GenPDF component.</p>
    <v-btn @click="createPdf">PDF</v-btn>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

const authStore = useAuthStore();

async function createPdf() {
  const url = `/cert.pdf`;
  const fontUrl = `/THSarabun.ttf`; // actualyy sarabunPSK

  try {
    const [pdfResponse, fontResponse] = await Promise.all([
      fetch(url, {
        headers: {
          "Cache-Control": "no-cache",
          "X-Requested-With": "XMLHttpRequest",
        },
      }),
      fetch(fontUrl, {
        headers: {
          "Cache-Control": "no-cache",
          "X-Requested-With": "XMLHttpRequest",
        },
      }),
    ]);

    if (!pdfResponse.ok) {
      throw new Error(`PDF fetch failed: ${pdfResponse.status}`);
    }

    if (!fontResponse.ok) {
      throw new Error(`Font fetch failed: ${fontResponse.status}`);
    }

    const [existingPdfBytes, fontBytes] = await Promise.all([
      pdfResponse.arrayBuffer(),
      fontResponse.arrayBuffer(),
    ]);

    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const fontkit = await import("@pdf-lib/fontkit");
    pdfDoc.registerFontkit(fontkit.default || fontkit);
    pdfDoc.setTitle("ใบประกาศนียบัตร");
    const customFont = await pdfDoc.embedFont(fontBytes);
    const Name = `${authStore.user.displayName}`.normalize("NFC");

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const { width, height } = firstPage.getSize();

    // 1. Define the font size for the name
    const fontSize = 50;

    // 2. Calculate the width of the text using the font and size
    const textWidth = customFont.widthOfTextAtSize(Name, fontSize);

    // 3. Calculate the new x-coordinate to center the text
    const textX = (width - textWidth) / 2;

    firstPage.drawText(Name, {
      x: textX, // Use the new, calculated X coordinate
      y: 295,
      size: fontSize,
      font: customFont,
      color: rgb(0.0824, 0.298, 0.4745),
    });

    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open in new tab
    window.open(pdfUrl, "_blank");

    // Create download link with custom filename
    const downloadLink = document.createElement("a");
    //downloadLink.href = pdfUrl;
    downloadLink.download = `${Name}-certificate.pdf`; // Custom filename
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    setTimeout(() => {
      URL.revokeObjectURL(pdfUrl);
    }, 1000);
  } catch (error) {
    console.error("Error:", error.message);
  }
}
</script>
